module.exports = __webpack_public_path__ + "media/images/logo/logo_prex_rosso-11e48057ee8d40d29606fdb5c9cbd8ce.png";